import React, { Component } from "react";
import Scrollbars from "react-custom-scrollbars-2";

import styles from "./analisesSignalTree.module.scss";
import { withIntelligenceControl } from "../../shared/containers/containerIntelligenceControl";
import { Checkbox, FormControl, RadioGroup } from "@mui/material";
import { withAnaliseSignal } from "../../shared/containers/containerAnaliseSignal";
import { withMapPositions } from "../../shared/containers/containerMapPositions";
import { states } from "../../reducers/queriesStates";
import { withTimerangeIntelligence } from "../../shared/containers/containerTimerangeIntelligence";
import { withCars } from "../../shared/containers/containerCars";
import Preloader from "../../shared/items/static/preloader";
import ConnectionItem from "./ConnectionItem";

const filter = {
  filterObject: { byUnit: "byUnit", byDevice: "byDevice" },
  filterTime: { byPointTime: "byPointTime", byPackageTime: "byPackageTime" },
};

class AnalisesSignalTree extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filterObject: filter.filterObject.byUnit,
      filterTime: filter.filterTime.byPointTime,
      connections: null,
      isAllOpen: false,
      isViewPoints: false,
    };
  }

  onClickColapseButton(isAllOpen) {
    this.setState({ isAllOpen });
  }

  componentDidMount() {
    const { analiseSignalDataState, analiseSignals } = this.props;
    if (analiseSignalDataState === states.READY) {
      this.setState({ connections: JSON.parse(JSON.stringify(analiseSignals.data)) });
    }
  }

  componentDidUpdate(prevProps) {
    const { mapPositionsDataState, onGetAnaliseSignal, startDate, endDate, listUnits, carId, analiseSignalDataState, analiseSignals } =
      this.props;

    const { filterObject, filterTime } = this.state;

    if (mapPositionsDataState === states.REQUEST && prevProps.mapPositionsDataState !== states.REQUEST) {
      onGetAnaliseSignal({
        deviceId:
          filterObject === filter.filterObject.byDevice
            ? listUnits.filter((x) => {
                return x.id === carId;
              })[0].devices[0].id
            : null,
        unitId: filterObject === filter.filterObject.byUnit ? carId : null,
        startDate,
        endDate,
        byPackageTime: filterTime === filter.filterTime.byPackageTime,
      });

      this.setState({ connections: null });
    }

    if (analiseSignalDataState === states.READY && prevProps.analiseSignalDataState === states.REQUEST) {
      this.setState({ connections: JSON.parse(JSON.stringify(analiseSignals.data)) });
    }
  }

  radioHandleChange(value) {
    switch (value) {
      case filter.filterObject.byUnit:
        this.setState({ filterObject: filter.filterObject.byUnit });
        break;
      case filter.filterObject.byDevice:
        this.setState({ filterObject: filter.filterObject.byDevice });
        break;
      case filter.filterTime.byPointTime:
        this.setState({ filterTime: filter.filterTime.byPointTime });
        break;
      case filter.filterTime.byPackageTime:
        this.setState({ filterTime: filter.filterTime.byPackageTime });
        break;

      default:
        break;
    }
  }

  getControl() {
    const { isViewPoints } = this.state;

    return (
      <FormControl>
        <RadioGroup row aria-labelledby="demo-row-radio-buttons-group-label" name="row-radio-buttons-group">
          <div className={styles.analisesSignalTreeControll}>
            <div className={styles.colapseButton} onClick={this.onClickColapseButton.bind(this, true)}>
              Развернуть все
            </div>
            <div className={styles.colapseButton} onClick={this.onClickColapseButton.bind(this, false)}>
              Свернуть все
            </div>

            <div>
              <Checkbox
                checked={isViewPoints}
                onChange={() => {
                  this.setState({ isViewPoints: !isViewPoints });
                }}
              />
              Показать точки
            </div>
          </div>
        </RadioGroup>
      </FormControl>
    );
  }

  render() {
    const { fullScreen, analiseSignalDataState } = this.props;
    const { connections, isAllOpen, isViewPoints } = this.state;

    if (analiseSignalDataState === states.NOT_REQUESTED) {
      return this.getControl();
    }

    if (connections === null) {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Preloader />
        </div>
      );
    }

    return (
      <div>
        {this.getControl()}

        <Scrollbars ref="scrollbar" style={{ height: fullScreen ? "530px" : "370px" }} autoHide={false}>
          <div className={styles.analisesSignalTreeContainer}>
            {connections.map((x, index) => {
              return <ConnectionItem item={x} key={index} isOpen={isAllOpen} isViewPoints={isViewPoints} />;
            })}
          </div>
        </Scrollbars>
      </div>
    );
  }
}

export default withCars(
  withMapPositions(withAnaliseSignal(withIntelligenceControl(withTimerangeIntelligence(React.memo(AnalisesSignalTree)))))
);
